import { purchaseIntentionMode } from 'json/sign'
export let notesLabels = [
  {
    label: '姓名',
    value: 'genericFormData.data.name'
  },
  {
    label: '手机号',
    value: 'genericFormData.data.phone',
    minWidth: 120
  },
  {
    label: '合同书号',
    value: 'genericFormData.data.contractNumber'
  },
  {
    label: '预约人数',
    value: 'genericFormData.data.personNumber'
  },
  {
    label: '选择优惠',
    value: 'userOption.remark'
  },
  {
    label: '定金',
    value: 'promotion_amount'
  },
  {
    label: '报名时间',
    value: 'registration_time',
    minWidth: 150
  },
  {
    label: '预约状态',
    value: 'sign_status'
  }
]
export let LifeExperienceHallnotesLabels = [
  {
    label: '姓名',
    value: 'genericFormData.data.name'
  },
  {
    label: '手机号',
    value: 'genericFormData.data.phone',
    minWidth: 120
  },
  {
    label: '预约场馆',
    value: 'genericFormData.data.experienceHall.name'
  },
  {
    label: '预约人数',
    value: 'genericFormData.data.personNumber'
  },
  {
    label: '报名时间',
    value: 'registration_time',
    minWidth: 150
  },
  {
    label: '预约状态',
    value: 'sign_status'
  }
]
export let notesOfQuestionLabels = [
  {
    label: '姓名',
    value: 'genericFormData.data.name'
  },
  {
    label: '手机号',
    value: 'genericFormData.data.phone',
    minWidth: 120
  },
  {
    label: '所属城市',
    value: 'genericFormData.data.city_show',
    minWidth: 120
  },
  {
    label: '报名时间',
    value: 'registration_time',
    minWidth: 150
  },
  {
    label: '预约状态',
    value: 'sign_status'
  }
]
export let notesOfQuestionInReportLabels = [
  {
    label: '姓名',
    value: 'satisfactionSurveyAssociateInfo.reportUserName'
  },
  {
    label: '手机号',
    value: 'satisfactionSurveyAssociateInfo.reportUserMobile',
    minWidth: 120
  },
  {
    label: '地区',
    value: 'area'
  },
  {
    label: '解读报告名称',
    value: 'satisfactionSurveyAssociateInfo.reportName'
  },
  {
    label: '解读人员',
    value: 'allotUserName'
  },
  {
    label: '解读时间',
    value: 'unscramble_date'
  },
  {
    label: '回答问卷时间',
    value: 'registration_time',
    minWidth: 150
  },
  {
    label: '预约状态',
    value: 'sign_status'
  }
]
export let parseNotesLabels = [
  {
    label: '姓名',
    value: 'genericFormData.data.name'
  },
  {
    label: '手机号',
    value: 'genericFormData.data.phone',
    maxWidth: 110
  },
  {
    label: '报告姓名',
    value: 'genericFormData.data.patientName'
  },
  {
    label: '报告名称',
    value: 'genericFormData.data.reportName',
    maxWidth: 100
  },
  {
    label: '样本条码号',
    value: 'genericFormData.data.sampleId',
    maxWidth: 130
  },
  {
    label: '报名时间',
    value: 'registration_time',
    maxWidth: 100
  },
  {
    label: '地区',
    value: 'area'
  },
  {
    label: '已分配人员',
    value: 'allotUserName',
    maxWidth: 100
  },
  {
    label: '解读完成时间',
    value: 'unscramble_date',
    maxWidth: 105
  }
]
export let reportStatusOptions = [
  {
    label: '已预约',
    value: 'SUCCESS'
  },
  {
    label: '已取消',
    value: 'CANCEL'
  }
]
export let filterLabelsActive = [
  {
    label: '报名时间',
    type: 'time-slot',
    clearable: true,
    startName: 'startTime',
    endName: 'endTime',
    value: 'signTime'
  },
  {
    label: '预约状态',
    type: 'select',
    clearable: true,
    options: [
      {
        label: '待支付',
        value: 'WAIT_FOR_PAY'
      },
      {
        label: '已预约',
        value: 'SUCCESS'
      },
      {
        label: '已取消',
        value: 'CANCEL'
      }
    ],
    value: 'userRegistrationStatus'
  }
]
export let readReportLabels = [
  {
    label: '地区',
    type: 'select',
    clearable: true,
    options: [],
    value: 'area'
  },
  {
    label: '复购意向',
    type: 'select',
    clearable: true,
    options: purchaseIntentionMode,
    value: 'repurchaseIntention'
  },
  {
    label: '已分配人员',
    type: 'select',
    clearable: true,
    options: [],
    value: 'allotUserId'
  }
]
export let allotUnscrambleUserLabels = [
  {
    label: '分配',
    type: 'select',
    clearable: true,
    options: [
      {
        label: '已分配',
        value: 'true'
      },
      {
        label: '未分配',
        value: 'false'
      }
    ],
    value: 'isAllotUnscrambleUser'
  }
]
// 解读师列表表头
export let readPeopleTableLabels = [
  {
    label: '姓名',
    value: 'name'
  },
  {
    label: '当前的解读次数',
    value: 'currentUnscrambleTime'
  },
  {
    label: '一周内的最大解读次数',
    value: 'unscrambleTimePerWeek'
  },
  {
    label: '微信号',
    value: 'wechatId'
  }
]
// 20周年活动列表表头
export let twentyAnniversaryLabels = [
  {
    label: '母亲姓名',
    value: 'genericFormData.data.name',
    minWidth: 60
  },
  {
    label: '母亲手机号',
    value: 'genericFormData.data.phone',
    minWidth: 90
  },
  {
    label: '储存地区',
    value: 'address_show'
  },
  {
    label: '储存时间',
    value: 'time'
  },
  {
    label: '参观场馆',
    value: 'genericFormData.data.experienceHall.name',
    minWidth: 100
  },
  {
    label: '参观时间',
    value: 'parse_date'
  },
  {
    label: '参观人数',
    value: 'genericFormData.data.personNumber'
  },
  {
    label: '所属公司',
    value: 'genericFormData.data.organizationName'
  },
  {
    label: '预约状态',
    value: 'sign_status'
  },
  {
    label: '客户姓名',
    value: 'signInUser.firstName'
  },
  {
    label: '手机号',
    value: 'signInUser.mobile',
    minWidth: 90
  },
  {
    label: '打卡时间',
    value: 'sign_in_time'
  }
]
// 20周年满意度调查表头
export let twentySurveyLabels = [
  {
    label: '母亲姓名',
    value: 'genericFormData.data.motherName'
  },
  {
    label: '手机号',
    value: 'genericFormData.data.phone',
    minWidth: 120
  },
  {
    label: '合同号',
    value: 'genericFormData.data.contractNumber',
    minWidth: 120
  },
  {
    label: '报名时间',
    value: 'registration_time',
    minWidth: 150
  },
  {
    label: '预约状态',
    value: 'sign_status'
  }
]